import { mapBaseAudioFile, mapBaseAudio } from './BaseAudio.mappers';
export const mapAudio = (audio, file) => {
  const baseAudioOutput = mapBaseAudio(audio, file);
  const urlRegex = /mp3\/.*\.mp3$/;
  const url = audio.url || '';
  const match = url.match(urlRegex);
  return {
    ...baseAudioOutput,
    url: match ? match[0] : '',
    quality: audio.quality || ''
  };
};
const mapAudioFileOutput = file => {
  var _file$media;
  const assets = ((_file$media = file.media) == null || (_file$media = _file$media.audio) == null ? void 0 : _file$media.assets) || [];
  const audios = assets.map(asset => mapAudio(asset, file));
  return {
    audio: audios
  };
};
export const mapAudioFile = (file, baseFile) => {
  const baseAudioFileDescriptor = mapBaseAudioFile(file, baseFile);
  return {
    mediaType: 'music',
    fileOutput: mapAudioFileOutput(file),
    ...baseAudioFileDescriptor
  };
};
//# sourceMappingURL=Audio.mappers.js.map